export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';

export const WEBSOCKET_URL = import.meta.env.VITE_WS_URL || 'ws://localhost:3001';

export const QUERY_KEYS = {
  phoneboards: ['phoneboards'],
  accounts: ['accounts'],
  tasks: ['tasks'],
  stats: ['stats'],
  user: ['user'],
} as const;

export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  PHONEBOARDS: '/phoneboards',
  PHONEBOARD_DETAIL: '/phoneboards/:id',
  ACCOUNTS: '/accounts',
  SNS_ACCOUNTS: '/sns-accounts',
  TASKS: '/tasks',
  TASK_HISTORY: '/task-history',
  NOTIFICATIONS: '/notifications',
} as const;

export const COLORS = {
  primary: '#165DFF',
  secondary: '#36BFFA',
  success: '#00B42A',
  warning: '#FF7D00',
  danger: '#F53F3F',
  gray: {
    100: '#F2F3F5',
    200: '#E5E6EB',
    300: '#C9CDD4',
    400: '#86909C',
    500: '#4E5969',
    600: '#272E3B',
    700: '#1D2129',
  }
} as const;

export const PHONEBOARD_STATUS = {
  NORMAL: 'normal',
  PARTIAL_ERROR: 'partial_error',
  ERROR: 'error',
} as const;

export const ACCOUNT_STATUS = {
  LOGGED_IN: 'logged_in',
  LOGGED_OUT: 'logged_out',
  BLOCKED: 'blocked',
} as const;

export const TASK_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;